import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {CheckBox, CheckBoxOutlineBlank} from '@mui/icons-material';
import {theme} from '../../Theme';

interface IProps {
  checked?: boolean;
  defaultChecked?: boolean;
  value?: boolean;
  label?: any;
  name?: string;
  onChange?: any;
  secondary?: boolean;
  size?: string;
  style?: any;
  classes?: any;
  color?: string;
  disabled?: boolean;
}

export default function BidmiiCheckbox(props: IProps) {
  const checkbox = (
    <Checkbox
      checked={props.checked}
      defaultChecked={props.defaultChecked}
      value={props.value}
      disabled={props.disabled}
      icon={
        <CheckBoxOutlineBlank
          style={{
            color: !props.disabled
              ? theme.palette.gray.medium
              : theme.palette.gray.border,
          }}
        />
      }
      checkedIcon={
        <CheckBox style={{color: props.color || theme.palette.blue.main}} />
      }
      name={props.name}
    />
  );

  if (!props.label) {
    return (
      <div style={{marginLeft: -11}} onClick={props.onChange}>
        {checkbox}
      </div>
    );
  }

  return (
    <FormControlLabel
      control={checkbox}
      label={props.label}
      labelPlacement={props.secondary ? 'start' : 'end'}
      onChange={props.onChange}
      disabled={props.disabled}
      sx={{
        marginLeft: '-11px',
        padding: '8px 0',
        minHeight: 48,
        ...(props.secondary && {
          justifyContent: 'space-between',
          width: '100%',
        }),
        '& .MuiFormControlLabel-label': {
          fontSize: props.size === 'small' ? 12 : 14,
          lineHeight: 1.3,
          fontFamily: 'AeonikProReqular, sans-serif',
          color: !props.disabled
            ? theme.palette.text.primary
            : theme.palette.text.secondary,
        },
      }}
      style={{...props.style}}
    />
  );
}
